export default {"src":"/_next/static/image/public/images/logo-dark.e546f11d2371470cbd5c2b2e6f628a2d.svg","height":155,"width":182};